import React, { FC } from 'react';
import LayerElement from './LayerElement';

export const PageElement: FC = () => {
  return <LayerElement id={'ROOT'} />;
};

export default PageElement;
